import { SelectButton } from 'primereact/selectbutton';
import React from 'react';
import { v4 } from 'uuid';

const C2BtnGroup = (props) => {
    const { opts } = props;
    const id = v4();
    const justifyTemplate = (option) => {
        return React.createElement("i", { className: option.icon });
    };
    return React.createElement("span", { className: "field" },
        React.createElement("label", { htmlFor: id }, opts.label),
        React.createElement(SelectButton, { id: id, className: "w-full flex justify-content-between", options: opts.options, itemTemplate: justifyTemplate }));
};

export { C2BtnGroup as default };
//# sourceMappingURL=C2BtnGroup.js.map
